
import {defineComponent} from 'vue'
import {mapGetters} from 'vuex'
import YieldForm from '../../components/form/bond/YieldForm.vue'

export default defineComponent({
  name: 'YieldCheckDash',
  components: {
    YieldForm
  },
  computed: {
    ...mapGetters([
      'isStaff'
    ])
  }
});
